import * as React from 'react';
import './Region.less';
import { EditIcon } from '@ui/components';

interface Props {
  region: any;
  onClick: (region: any) => void;
  onOpenEditEntity: (id: string, value: string, type: string) => void;
  onOpenRemoveEntity: (id: string, value: string, type: string) => void;
  isOpenEditPanel: boolean;
}

const Region: React.FunctionComponent<Props> = ({
  onClick,
  region: { id, name, cities },
  onOpenEditEntity,
  onOpenRemoveEntity,
  isOpenEditPanel,
}) => (
  <div className="stores-region">
    <div className="stores-region__panel">
      <span>{name}</span>
      {isOpenEditPanel && (
        <div className="stores-region__panel__edit">
          <EditIcon
            type="edit"
            // @ts-ignore
            onClick={(event: any) => {
              event.stopPropagation();
              onOpenEditEntity(id, name, 'region');
            }}
          />
          <EditIcon
            type="remove"
            // @ts-ignore
            onClick={event => {
              event.stopPropagation();
              onOpenRemoveEntity(id, name, 'region');
            }}
          />
        </div>
      )}
    </div>
    <div className="stores-region-cities">
      {cities.map((city: any) => (
        <div
          key={city.id}
          className="stores-region-cities__item"
          onClick={() => onClick({ city, region: { id, name } })}
        >
          <span style={{ paddingLeft: '16px' }}>{city.name}</span>
          {isOpenEditPanel && (
            <div className="stores-region-cities__item__edit">
              <EditIcon
                type="edit"
                // @ts-ignore
                onClick={(event: any) => {
                  event.stopPropagation();
                  onOpenEditEntity(city.id, city.name, 'city');
                }}
              />
              <EditIcon
                type="remove"
                // @ts-ignore
                onClick={(event: any) => {
                  event.stopPropagation();
                  onOpenRemoveEntity(city.id, city.name, 'city');
                }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
);

export default Region;



// WEBPACK FOOTER //
// ./src/scenes/Stores/components/Region/Region.tsx